import { render, staticRenderFns } from "./NormalSearchNav252.vue?vue&type=template&id=fa12b5ce&scoped=true&"
import script from "./NormalSearchNav252.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav252.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa12b5ce",
  null
  
)

export default component.exports